export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#050505] mt-24">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 grid grid-cols-1 sm:grid-cols-3 gap-8">
      <div>
        <div className="font-heading text-2xl font-900 tracking-tight uppercase mb-3">
          <span className="text-[#E63946]">CHRIST</span><span className="text-white">RACING</span>
        </div>
        <p className="text-sm text-[#A1A1AA] leading-relaxed max-w-xs">
          Faith-fueled apparel and stickers for those who run their race with endurance. Hebrews 12:1.
        </p>
      </div>
      <div>
        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#52525B] mb-4">Shop</h4>
        <ul className="space-y-2 text-sm text-[#A1A1AA]">
          <li><a href="/shop?category=shirts" className="hover:text-white transition-colors">Shirts</a></li>
          <li><a href="/shop?category=stickers" className="hover:text-white transition-colors">Stickers</a></li>
          <li><a href="/shop" className="hover:text-white transition-colors">All Products</a></li>
        </ul>
      </div>
      <div>
        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#52525B] mb-4">Payments Accepted</h4>
        <p className="text-sm text-[#A1A1AA] leading-relaxed">
          Credit &amp; Debit Cards, Apple Pay, Google Pay via Stripe. PayPal &amp; Venmo at checkout.
        </p>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-[#52525B]">
      © {new Date().getFullYear()} ChristRacing.com — Keep Moving Forward.
    </div>
  </footer>
);
